import { render, staticRenderFns } from "./ExibirMandato.vue?vue&type=template&id=1f7c15ec&scoped=true&"
import script from "./ExibirMandato.vue?vue&type=script&lang=js&"
export * from "./ExibirMandato.vue?vue&type=script&lang=js&"
import style0 from "./ExibirMandato.vue?vue&type=style&index=0&id=1f7c15ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7c15ec",
  null
  
)

export default component.exports